export var DASHBOARD;
(function (DASHBOARD) {
    DASHBOARD[DASHBOARD["ROOT"] = 1] = "ROOT";
    DASHBOARD[DASHBOARD["CUSTOMER"] = 2] = "CUSTOMER";
    DASHBOARD[DASHBOARD["ACCOUNT"] = 3] = "ACCOUNT";
    DASHBOARD[DASHBOARD["FAST_LNK_ENGAGEMENT"] = 4] = "FAST_LNK_ENGAGEMENT";
})(DASHBOARD || (DASHBOARD = {}));
export var CUSTOMERS;
(function (CUSTOMERS) {
    CUSTOMERS[CUSTOMERS["ROOT"] = 5] = "ROOT";
    CUSTOMERS[CUSTOMERS["CUSTOMER_STATUS"] = 7] = "CUSTOMER_STATUS";
    CUSTOMERS[CUSTOMERS["LOGIN_TO_APP_AS_CUSTOMERS"] = 6] = "LOGIN_TO_APP_AS_CUSTOMERS";
    CUSTOMERS[CUSTOMERS["ACCOUNTS_STATUS"] = 26] = "ACCOUNTS_STATUS";
})(CUSTOMERS || (CUSTOMERS = {}));
export var USER_MANAGEMENT;
(function (USER_MANAGEMENT) {
    USER_MANAGEMENT[USER_MANAGEMENT["ROOT"] = 18] = "ROOT";
    USER_MANAGEMENT[USER_MANAGEMENT["DELETE"] = 27] = "DELETE";
    USER_MANAGEMENT[USER_MANAGEMENT["EDIT"] = 21] = "EDIT";
    USER_MANAGEMENT[USER_MANAGEMENT["STATUS"] = 22] = "STATUS";
    USER_MANAGEMENT[USER_MANAGEMENT["CREATE"] = 20] = "CREATE";
    USER_MANAGEMENT[USER_MANAGEMENT["MANAGE_PERMISSION"] = 19] = "MANAGE_PERMISSION";
})(USER_MANAGEMENT || (USER_MANAGEMENT = {}));
export var SENSITIVE;
(function (SENSITIVE) {
    SENSITIVE[SENSITIVE["ROOT"] = 8] = "ROOT";
    SENSITIVE[SENSITIVE["BALANCE"] = 16] = "BALANCE";
    SENSITIVE[SENSITIVE["TRANSACTION"] = 17] = "TRANSACTION";
    SENSITIVE[SENSITIVE["NET_WORTH"] = 24] = "NET_WORTH";
    SENSITIVE[SENSITIVE["HOLDER"] = 9] = "HOLDER";
})(SENSITIVE || (SENSITIVE = {}));
export var HOLDER;
(function (HOLDER) {
    HOLDER[HOLDER["ROOT"] = 9] = "ROOT";
    HOLDER[HOLDER["EMAIL"] = 12] = "EMAIL";
    HOLDER[HOLDER["PHONE"] = 13] = "PHONE";
    HOLDER[HOLDER["ADDRESS"] = 11] = "ADDRESS";
    HOLDER[HOLDER["NAME"] = 10] = "NAME";
})(HOLDER || (HOLDER = {}));
export var SERVICE_REQUESTS;
(function (SERVICE_REQUESTS) {
    SERVICE_REQUESTS[SERVICE_REQUESTS["ROOT"] = 25] = "ROOT";
    SERVICE_REQUESTS[SERVICE_REQUESTS["SUPPORT_GROUPS"] = 23] = "SUPPORT_GROUPS";
})(SERVICE_REQUESTS || (SERVICE_REQUESTS = {}));
export var OPEN_BANKING;
(function (OPEN_BANKING) {
    OPEN_BANKING[OPEN_BANKING["ROOT"] = 28] = "ROOT";
    OPEN_BANKING[OPEN_BANKING["CLIENT_SECRET"] = 29] = "CLIENT_SECRET";
})(OPEN_BANKING || (OPEN_BANKING = {}));
export var PRODUCTS;
(function (PRODUCTS) {
    PRODUCTS[PRODUCTS["ROOT"] = 31] = "ROOT";
})(PRODUCTS || (PRODUCTS = {}));
export var FEATURE_ROLLOUT;
(function (FEATURE_ROLLOUT) {
    FEATURE_ROLLOUT[FEATURE_ROLLOUT["ROOT"] = 32] = "ROOT";
})(FEATURE_ROLLOUT || (FEATURE_ROLLOUT = {}));
export var ANALYTICS;
(function (ANALYTICS) {
    ANALYTICS[ANALYTICS["ROOT"] = 33] = "ROOT";
})(ANALYTICS || (ANALYTICS = {}));
export var NEW_SITE_REQUEST;
(function (NEW_SITE_REQUEST) {
    NEW_SITE_REQUEST[NEW_SITE_REQUEST["ROOT"] = 35] = "ROOT";
})(NEW_SITE_REQUEST || (NEW_SITE_REQUEST = {}));
export var NOTIFICATIONS;
(function (NOTIFICATIONS) {
    NOTIFICATIONS[NOTIFICATIONS["ROOT"] = 36] = "ROOT";
})(NOTIFICATIONS || (NOTIFICATIONS = {}));
export var TRIALS;
(function (TRIALS) {
    TRIALS[TRIALS["ROOT"] = 46] = "ROOT";
    TRIALS[TRIALS["CREDIT_ACCELARATOR"] = 47] = "CREDIT_ACCELARATOR";
    TRIALS[TRIALS["CONSUMER_INSIGHTS"] = 53] = "CONSUMER_INSIGHTS";
    TRIALS[TRIALS["VERIFICATION"] = 54] = "VERIFICATION";
    TRIALS[TRIALS["PFM"] = 55] = "PFM";
    TRIALS[TRIALS["SMB"] = 56] = "SMB";
    TRIALS[TRIALS["ATV"] = 57] = "ATV";
    TRIALS[TRIALS["ADVISOR_INSIGHTS"] = 59] = "ADVISOR_INSIGHTS";
})(TRIALS || (TRIALS = {}));
export var PRODUCT_AND_MARKETING_INSIGHTS;
(function (PRODUCT_AND_MARKETING_INSIGHTS) {
    PRODUCT_AND_MARKETING_INSIGHTS[PRODUCT_AND_MARKETING_INSIGHTS["ROOT"] = 48] = "ROOT";
    PRODUCT_AND_MARKETING_INSIGHTS[PRODUCT_AND_MARKETING_INSIGHTS["SEGMENTATION"] = 49] = "SEGMENTATION";
    PRODUCT_AND_MARKETING_INSIGHTS[PRODUCT_AND_MARKETING_INSIGHTS["PRODUCT_INSIGHTS"] = 50] = "PRODUCT_INSIGHTS";
    PRODUCT_AND_MARKETING_INSIGHTS[PRODUCT_AND_MARKETING_INSIGHTS["INSIGHTS_DASHBOARD"] = 51] = "INSIGHTS_DASHBOARD";
})(PRODUCT_AND_MARKETING_INSIGHTS || (PRODUCT_AND_MARKETING_INSIGHTS = {}));
export var INTERNAL_TOOLS;
(function (INTERNAL_TOOLS) {
    INTERNAL_TOOLS[INTERNAL_TOOLS["MERCHANT_METADATA"] = 52] = "MERCHANT_METADATA";
    INTERNAL_TOOLS[INTERNAL_TOOLS["SITE_METADATA"] = 60] = "SITE_METADATA";
    INTERNAL_TOOLS[INTERNAL_TOOLS["ASK_YODLEE_ADMIN_PORTAL"] = 61] = "ASK_YODLEE_ADMIN_PORTAL";
})(INTERNAL_TOOLS || (INTERNAL_TOOLS = {}));
//# sourceMappingURL=permission.js.map